import { NgModule } from '@angular/core';
import { AsyncPipe, CommonModule } from "@angular/common";
import { DescriptionHelperService } from "./description-helper.service";
import { HostAliasPipeModule } from "libraries/pipes/host-alias/host-alias-pipe.module";


@NgModule({
    imports: [
        CommonModule,
        HostAliasPipeModule,
    ],
    exports: [],
    declarations: [],
    providers: [
        DescriptionHelperService,
        AsyncPipe,
    ],
})
export class DescriptionHelperModule {
}
